import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/redbullLanding.css";

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div style={{ background: "#0e0e0e", color: "#e0e0e0", minHeight: "100vh", fontFamily: "'Bull Text', Arial, sans-serif" }}>
      <header style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "18px 40px", borderBottom: "1px solid #222" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14, cursor: "pointer" }} onClick={() => navigate("/")}>
          <img
            src="https://upload.wikimedia.org/wikipedia/en/thumb/8/8e/Red_Bull_Jobs_logo.svg/800px-Red_Bull_Jobs_logo.svg.png"
            alt="Red Bull"
            style={{ height: 32, filter: "brightness(0) invert(1)" }}
            onError={(e) => { e.target.style.display = "none"; }}
          />
          <span style={{ fontFamily: "'Bull', sans-serif", fontWeight: 700, fontSize: 20, color: "#fff" }}>Red Bull Jobs</span>
        </div>
        <button
          onClick={() => navigate("/")}
          style={{ background: "none", border: "1px solid #555", color: "#fff", padding: "8px 20px", borderRadius: 4, cursor: "pointer", fontSize: 14, fontFamily: "'Bull Text', sans-serif" }}
        >
          Back to Home
        </button>
      </header>

      <main style={{ maxWidth: 820, margin: "0 auto", padding: "48px 24px 80px" }}>
        <h1 style={{ fontFamily: "'Bull', sans-serif", fontWeight: 800, fontSize: 36, color: "#fff", marginBottom: 8 }}>Privacy Policy</h1>
        <p style={{ color: "#888", fontSize: 14, marginBottom: 36 }}>Last updated: February 20, 2026</p>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>1. Introduction</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            Red Bull GmbH and its affiliated companies ("Red Bull", "we", "us", or "our") are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our careers website and use our recruitment services.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>2. Information We Collect</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb", marginBottom: 12 }}>We may collect the following types of information:</p>
          <ul style={{ color: "#bbb", lineHeight: 1.8, paddingLeft: 24 }}>
            <li><strong style={{ color: "#e0e0e0" }}>Personal Information:</strong> Name, email address, phone number, and other contact details you provide when applying for a position.</li>
            <li><strong style={{ color: "#e0e0e0" }}>Account Information:</strong> Information from third-party accounts (such as Google) if you choose to sign in using those services.</li>
            <li><strong style={{ color: "#e0e0e0" }}>Usage Data:</strong> Browser type, IP address, pages visited, time spent on pages, and other diagnostic data.</li>
            <li><strong style={{ color: "#e0e0e0" }}>Cookies:</strong> We use cookies and similar tracking technologies to enhance your experience on our site.</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>3. How We Use Your Information</h2>
          <ul style={{ color: "#bbb", lineHeight: 1.8, paddingLeft: 24 }}>
            <li>Process and evaluate your job applications</li>
            <li>Communicate with you about open positions and recruitment updates</li>
            <li>Improve and personalize your experience on our platform</li>
            <li>Comply with legal obligations and protect our rights</li>
            <li>Analyze usage patterns to improve our services</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>4. Sharing of Information</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            We do not sell your personal information. We may share your data with trusted third-party service providers who assist us in operating our website, conducting our business, or serving you. These parties are obligated to keep your information confidential. We may also disclose your information when required by law or to protect our rights.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>5. Data Security</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>6. Cookies and Tracking</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            Our website uses cookies to distinguish you from other users, provide a better browsing experience, and analyze site traffic. You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies. If you disable or refuse cookies, some parts of this website may become inaccessible or not function properly.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>7. Third-Party Services</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            Our site may integrate with third-party services such as Google Sign-In and Calendly for scheduling. These services have their own privacy policies, and we encourage you to review them. We are not responsible for the privacy practices of third-party services.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>8. Your Rights</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb", marginBottom: 12 }}>Depending on your location, you may have the right to:</p>
          <ul style={{ color: "#bbb", lineHeight: 1.8, paddingLeft: 24 }}>
            <li>Access the personal data we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your personal data</li>
            <li>Object to or restrict certain processing of your data</li>
            <li>Withdraw consent at any time where processing is based on consent</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>9. Data Retention</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            We retain your personal information only for as long as necessary to fulfill the purposes for which it was collected, including satisfying legal, accounting, or reporting requirements. Application data is typically retained for up to 24 months after the recruitment process concludes.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>10. Contact Us</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            If you have questions about this Privacy Policy or wish to exercise your data rights, please contact us at:
          </p>
          <p style={{ lineHeight: 1.7, color: "#bbb", marginTop: 8 }}>
            <strong style={{ color: "#e0e0e0" }}>Red Bull GmbH</strong><br />
            Am Brunnen 1<br />
            5330 Fuschl am See, Austria<br />
            Email: privacy@redbull.com
          </p>
        </section>
      </main>

      <footer style={{ borderTop: "1px solid #222", padding: "24px 40px", textAlign: "center" }}>
        <span style={{ color: "#666", fontSize: 13 }}>© 2026 Red Bull GmbH. All rights reserved.</span>
      </footer>
    </div>
  );
}
